import.meta.rspackPublicPath = window.additionalServerData?.config?.CDN_PUBLIC_PATH ?? '/'
